"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RingContactList = void 0;
const ordered_map_1 = require("@js-sdsl/ordered-map");
const ringIdentifiers_1 = require("./ringIdentifiers");
const identifiers_1 = require("../../identifiers");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
class RingContactList extends eventemitter3_1.default {
    numNeighborsPerSide = 5;
    referenceId;
    excludedIds;
    leftNeighbors;
    rightNeighbors;
    constructor(rawReferenceId, excludedIds) {
        super();
        this.referenceId = (0, ringIdentifiers_1.getRingIdFromRaw)(rawReferenceId);
        this.excludedIds = excludedIds ?? new Set();
        this.leftNeighbors = new ordered_map_1.OrderedMap();
        this.rightNeighbors = new ordered_map_1.OrderedMap();
    }
    addContact(contact) {
        const id = (0, ringIdentifiers_1.getRingIdFromPeerDescriptor)(contact.getPeerDescriptor());
        if (id === this.referenceId || this.excludedIds.has((0, identifiers_1.toNodeId)(contact.getPeerDescriptor()))) {
            return;
        }
        let elementAdded = false;
        let elementRemoved = false;
        const leftDistance = (0, ringIdentifiers_1.getLeftDistance)(this.referenceId, id);
        const lastLeftNeighbor = this.leftNeighbors.back();
        if (lastLeftNeighbor === undefined || leftDistance < lastLeftNeighbor[0]) {
            this.leftNeighbors.setElement(leftDistance, contact);
            elementAdded = true;
            if (this.leftNeighbors.size() > this.numNeighborsPerSide) {
                this.leftNeighbors.eraseElementByIterator(this.leftNeighbors.rBegin());
                elementRemoved = true;
            }
        }
        const rightDistance = (0, ringIdentifiers_1.getRightDistance)(this.referenceId, id);
        const lastRightNeighbor = this.rightNeighbors.back();
        if (lastRightNeighbor === undefined || rightDistance < lastRightNeighbor[0]) {
            this.rightNeighbors.setElement(rightDistance, contact);
            elementAdded = true;
            if (this.rightNeighbors.size() > this.numNeighborsPerSide) {
                this.rightNeighbors.eraseElementByIterator(this.rightNeighbors.rBegin());
                elementRemoved = true;
            }
        }
        if (this.hasEventListeners() && (elementAdded || elementRemoved)) {
            if (elementAdded) {
                this.emit('contactAdded', contact);
            }
            if (elementRemoved) {
                this.emit('contactRemoved', contact);
            }
        }
    }
    removeContact(contact) {
        if (contact === undefined) {
            return;
        }
        const id = (0, ringIdentifiers_1.getRingIdFromPeerDescriptor)(contact.getPeerDescriptor());
        const leftDistance = (0, ringIdentifiers_1.getLeftDistance)(this.referenceId, id);
        const rightDistance = (0, ringIdentifiers_1.getRightDistance)(this.referenceId, id);
        let elementRemoved = false;
        if (this.leftNeighbors.eraseElementByKey(leftDistance)) {
            elementRemoved = true;
        }
        if (this.rightNeighbors.eraseElementByKey(rightDistance)) {
            elementRemoved = true;
        }
        if (this.hasEventListeners() && elementRemoved) {
            this.emit('contactRemoved', contact);
        }
    }
    getContact(peerDescriptor) {
        const id = (0, ringIdentifiers_1.getRingIdFromPeerDescriptor)(peerDescriptor);
        const leftDistance = (0, ringIdentifiers_1.getLeftDistance)(this.referenceId, id);
        const rightDistance = (0, ringIdentifiers_1.getRightDistance)(this.referenceId, id);
        if (this.leftNeighbors.getElementByKey(leftDistance)) {
            return this.leftNeighbors.getElementByKey(leftDistance);
        }
        if (this.rightNeighbors.getElementByKey(rightDistance)) {
            return this.rightNeighbors.getElementByKey(rightDistance);
        }
        return undefined;
    }
    getClosestContacts(limitPerSide) {
        const leftContacts = [];
        const rightContacts = [];
        let leftCount = 0;
        for (const item of this.leftNeighbors) {
            if (limitPerSide != undefined && leftCount >= limitPerSide) {
                break;
            }
            leftContacts.push(item[1]);
            leftCount++;
        }
        let rightCount = 0;
        for (const item of this.rightNeighbors) {
            if (limitPerSide != undefined && rightCount >= limitPerSide) {
                break;
            }
            rightContacts.push(item[1]);
            rightCount++;
        }
        return { left: leftContacts, right: rightContacts };
    }
    getAllContacts() {
        const ret = [];
        for (const item of this.leftNeighbors) {
            ret.push(item[1]);
        }
        for (const item of this.rightNeighbors) {
            ret.push(item[1]);
        }
        return ret;
    }
    hasEventListeners() {
        return this.eventNames().length > 0;
    }
}
exports.RingContactList = RingContactList;
//# sourceMappingURL=RingContactList.js.map